// PWHL conferences (from 2026-27). Team ids.
export const PWHL_CONFERENCES = {
    Eastern: ["bos", "ham", "mtl", "nyc", "ott", "tor"],
    Western: ["det", "lvs", "min", "sea", "sj", "van"],
};
export const pwhlConfOf = (id) => (PWHL_CONFERENCES.Western.includes(id) ? "Western" : PWHL_CONFERENCES.Eastern.includes(id) ? "Eastern" : null);
